<template>
  <b-card no-body class="flex-container grid-stack-item-content label-modal">
    <div slot="header">
      <window-header :cmp-title="'Labels for '+(layer.title || layer.name)" :widget-name="layer.id+'labels'"></window-header>
    </div>
    <div class="flex-full-height ">
      <b-list-group v-if="layer" class="h-100 label-list p-2">
        <template v-if="layer['fields'].length">
          <b-form-checkbox-group stacked v-model="labels" :options="availableFields">
          </b-form-checkbox-group>
          <!--<template v-for="label in layer['fields']">-->
          <!--<b-list-group-item  href="#">-->
          <!--<b-form-checkbox v-model="labels[label['name']]">-->
          <!--{{label['name']}}-->
          <!--</b-form-checkbox>-->
          <!--</b-list-group-item>-->
          <!--</template>-->
        </template>
        <template v-else>
          <p>No fields information available. Please, enable layer first</p>
        </template>
      </b-list-group>
    </div>
  </b-card>
  <!--<b-modal ref="labelModal"
           :title="'Label for layer '+(layer ? layer['name'] : '') " @hidden="onHidden">

    <div slot="modal-footer" class="w-100">
      <b-btn variant="secondary" @click="clearLabels">Clear Labels</b-btn>
      <b-btn class="float-right" variant="primary" @click="$refs.labelModal.hide()">Close</b-btn>
    </div>
  </b-modal>-->
</template>

<script>
  import WindowHeader from '../../common/WindowHeader'
  export default {
    name: 'LabelModel',
    components: {WindowHeader},
    data () {
      return {
        labels: [],
      }
    },
    mounted () {
      if (this.layer && this.$store.getters['map/renderedLabelsMap'][this.layer['name']]) {
        this.labels = this.$store.getters['map/renderedLabelsMap'][this.layer['name']]
      }
    },
    computed: {
      availableFields () {
        return this.layer['fields'].map(f => {
          return {
            value: f.name,
            text: f.name
          }
        })
      }
    },
    props: {
      layer: {
        default: null
      }
    },
    watch: {
      labels (val) {
        this.setLayerLabel(val)
      }
    },
    methods: {
      onHidden () {
        this.$destroy()
        $(this.$el).remove();
      },
      clearLabels () {
        this.$mapService.setLayerLabel(this.layer, null)
        this.$store.commit('map/setLayerLabel', [this.layer['name'], false])
      },
      setLayerLabel (label) {
        this.$mapService.setLayerLabel(this.layer, label)
        this.$store.commit('map/setLayerLabel', [this.layer['name'], label])
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/layers/LabelModel.vue